<template lang="pug">
  .promoCode

    .promoCode__button(v-if="!showPromoCodeForm" @click.prevent="showForm")
      cp-icon.promoCode__button__icon(path="/icons/add.svg")
      span.promoCode__button__label Adicionar cupom de desconto

    .promoCode__form(v-else)
      cp-field.promoCode__form__code(
        label="Cupom de desconto"
        for="code"
        id="code"
        type="search"
        name="code"
        placeholder="Digite o código aqui"
        size="small"
        autocomplete="off"
        :className="code && 'font-bold'"
        :value="code"
        :validation="codeValidation"
        @change="setCode"
      )

      cp-button.promoCode__form__apply(
        theme="outlined"
        size="small"
        label="Aplicar"
        :disabled="!code || promoCode.asyncPending || promoCode.valid !== null"
        @onClick="getPromoCode"
      )

    .promoCode__alert(v-if="recurrent && promoCode.activated")
      img.promoCode__alert__icon(src="@/assets/icons/success-with-circle.svg" alt="ícone")
      div
        strong.promoCode__alert__heading O cupom foi ativado!
        p.promoCode__alert__description O desconto aplicado permanece válido enquanto o seu plano estiver ativo.
</template>

<script>
import { mapState, mapActions } from 'vuex'

import views from '@/mixins/views'
import { required } from 'vuelidate/lib/validators'

import cpIcon from '@/components/atoms/Icon.vue'
import cpField from '@/components/molecules/Field.vue'
import cpButton from '@/components/atoms/Button.vue'

export default {
  name: 'PromoCode',
  mixins: [views],
  components: {
    cpIcon,
    cpField,
    cpButton
  },
  data () {
    return {
      showPromoCodeForm: false,
      searchCode: false
    }
  },
  validations: {
    code: {
      required
    }
  },
  watch: {
    code (newValue, oldValue) {
      if (newValue === oldValue) return

      this.setDirty(this.$v.code)
    }
  },
  computed: {
    ...mapState('product', ['recurrent']),
    ...mapState(['promoCode', 'plan']),
    ...mapState('payment', ['typePayment']),
    code () {
      return this.plan.promoCode.code
    },
    codeValidation () {
      const validations = [
        {
          type: 'loading',
          msg: 'Verificando código promocional...'
        },
        {
          type: 'error',
          msg: 'Código promocional inválido',
          isValid: false
        },
        {
          type: 'success',
          msg: 'Cupom ativado com sucesso!',
          isValid: true
        }
      ]

      if (this.promoCode.asyncPending) return validations[0]
      if (this.promoCode.valid === false && this.$v.code) return validations[1]
      if (this.promoCode.activated) return this.recurrent ? {} : validations[3]

      return {}
    }
  },
  created () {
    this.$root.$on('openPromoCodeForm', () => this.showForm())
    this.showPromoCodeForm = !!this.code
  },
  destroyed () {
    if (/BANK_SLIP|PIX|VOUCHER/.test(this.typePayment.method)) {
      this.cleanCampaign()
    }
  },
  methods: {
    ...mapActions('promoCode', ['changePromoCodeCommission']),
    ...mapActions('plan', ['changePlanPromoCodeCode']),
    ...mapActions('payment', ['cleanCampaign']),
    showForm () {
      this.showPromoCodeForm = true

      this.$nextTick(function () {
        if (document.getElementById('code')) {
          document.getElementById('code').focus()
        }
      })
    },
    setCode (value) {
      this.changePlanPromoCodeCode({
        code: value ? value.toUpperCase() : null,
        search: value ? this.searchCode : false
      })

      !value && this.cleanCampaign()

      this.searchCode = false
    },
    getPromoCode () {
      if (this.$v.code.$invalid || !this.$v.code.$dirty) {
        this.searchCode = false
        return
      }

      this.searchCode = true
      this.setCode(this.code)
      this.setClean(this.$v.code)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/style/_variables";

  .promoCode {
    font-family: $rubik-font-family;
    font-size: 14px;

    &__button {
      align-items: center;
      cursor: pointer;
      display: flex;
      margin: 0 auto;
      max-width: 236px;

      &__icon {
        height: 32px;
        width: 32px;
      }

      &__label {
        color: #595959;
        margin-left: 8px;
      }
    }

    &__form {
      @media screen and (min-width: 380px) {
        display: flex;
      }

      &__code {
        margin-right: 16px;
        margin-top: 0;
      }

      &__apply {
        margin-top: 20px;

        @media screen and (min-width: 380px) {
          margin-top: 26px;
          max-width: 129px;
        }
      }
    }

    &__alert {
      background-color: #1a71b417;
      border: 1px solid #1A71B4;
      border-radius: 8px;
      color: #444444;
      display: flex;
      margin-top: 20px;
      padding: 16px;

      @media screen and (max-width: 900px) {
        margin-top: 17px;
      }

      &__icon {
        height: 32px;
        margin-right: 16px;
        width: 32px;
      }

      &__heading {
        font-size: 16px;
      }

      &__description {
        line-height: 1.43;
        margin-top: 8px;
      }
    }
  }
</style>
